import { render, staticRenderFns } from "./OrderThankYou.vue?vue&type=template&id=842a37fc&"
import script from "./OrderThankYou.vue?vue&type=script&lang=js&"
export * from "./OrderThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports